import { Flex } from 'antd';
import { last, map, prop } from 'lodash/fp';
import { useContext, useMemo } from 'react';
import { SymptomCardData } from '../types';

/**
 * Styles that can only be done in CSS go in here
 */
import { Gauge3 } from 'components/gauge/gauge-3';
import { SymptomCard2Context } from '../symptom-card-2';
import { ScatterHistoricalChart } from './graph-historical-scatterchart';
/**
 * The initial state of a symptom card
 *
 * Shows a gauge with the latest value and a bar chart with data from previous months
 */
export function CurrentStatus(props: {
  id?: string;
  scale: number[];
  colors: string[];
  sortedData: SymptomCardData[];
  showLabels?: boolean;
  showValue?: boolean;
}) {
  /**
   * WARNING: This is unecessary. Use prop-passing instead
   */
  const ctx = useContext(SymptomCard2Context);

  /**
   * Get the last value in the list
   */
  const lastValue: number = useMemo(
    () =>
      // Get the last element
      last(
        // Get the `value` key
        map(
          prop('value'),
          // Sort the data in ascending order by date
          props.sortedData
        )
      ) ??
      
      /**
       * Otherwise show the minimum value that is available on the scale.
       * This ensures the gauge looks empty when there is no data
      */
      props.scale[0],
    [props.sortedData, props.scale]
  );

  return (
    <div id={props.id}>
      <Flex vertical justify={'space-around'} align={'center'} gap={'small'}>
        <Gauge3
          value={lastValue}
          scale={props.scale}
          width={150}
          height={(188 / 200) * 150}
          showLabels={props.showLabels ?? ctx.showNumbers}
          showValue={props.showValue ?? ctx.showNumbers}
        />

        {/*
         * Show aggregated data for the last 4 assessments
         */}
        <ScatterHistoricalChart
          data={props.sortedData}
          scale={props.scale}
          colors={props.colors}
          showValues={props.showValue ?? ctx.showNumbers}
        />
      </Flex>
    </div>
  );
}
